import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Settings2 } from "lucide-react";
import DemoCleanupCard from "./DemoCleanupCard";

// Platform-wide settings panel — community name, welcome banner, and the
// global registration kill switch.
export default function SettingsTab({ settings, setSettings, saveSettings }) {
  return (
    <div className="space-y-6">
    <div className="bg-white/80 border border-sage/20 rounded-3xl p-6 sm:p-8 shadow-sm max-w-2xl" data-testid="settings-tab">
      <h3 className="font-heading font-bold text-forest mb-4 flex items-center gap-2"><Settings2 className="w-5 h-5 text-sage-dark" /> Platform settings</h3>
      <div className="space-y-4">
        <div>
          <Label className="text-forest/80">Community name</Label>
          <Input value={settings.community_name} onChange={(e) => setSettings({ ...settings, community_name: e.target.value })} className="mt-1 rounded-xl bg-softstone/60 border-sage/30" data-testid="setting-name-input" />
        </div>
        <div>
          <Label className="text-forest/80">Welcome message</Label>
          <Textarea value={settings.welcome_message} onChange={(e) => setSettings({ ...settings, welcome_message: e.target.value })} rows={2} className="mt-1 rounded-xl bg-softstone/60 border-sage/30" data-testid="setting-welcome-input" />
        </div>
        <div>
          <Label className="text-forest/80">Announcement banner</Label>
          <Input value={settings.announcement_banner} onChange={(e) => setSettings({ ...settings, announcement_banner: e.target.value })} placeholder="Shown to all visitors (leave empty to hide)" className="mt-1 rounded-xl bg-softstone/60 border-sage/30" data-testid="setting-banner-input" />
        </div>
        <label className="flex items-center gap-2 text-sm text-forest/70">
          <Switch checked={settings.registration_open} onCheckedChange={(v) => setSettings({ ...settings, registration_open: v })} data-testid="setting-registration-switch" /> Registration open
        </label>
        <div className={`rounded-2xl border p-4 ${settings.payments_enabled === false ? "bg-amber-50 border-amber-300" : "bg-softstone/40 border-sage/20"}`} data-testid="setting-payments-block">
          <label className="flex items-center gap-2 text-sm font-semibold text-forest">
            <Switch checked={settings.payments_enabled !== false} onCheckedChange={(v) => setSettings({ ...settings, payments_enabled: v })} data-testid="setting-payments-switch" /> Payments & subscriptions required
          </label>
          <p className="text-xs text-forest/60 mt-1.5" data-testid="setting-payments-help">
            {settings.payments_enabled === false
              ? "Payments are OFF: everyone goes straight to their dashboard after verifying their email and completing their profile (admin approval still applies). Save to apply."
              : "When switched off, all checkout and subscription steps are skipped for every role. Payment code stays in place so you can switch it back on anytime."}
          </p>
          <div className="mt-3">
            <Label className="text-forest/80">Free until (banner & home page countdown)</Label>
            <Input
              type="date"
              value={settings.free_until || ""}
              onChange={(e) => setSettings({ ...settings, free_until: e.target.value || null })}
              className="mt-1 rounded-xl bg-white border-sage/30 max-w-[12rem]"
              data-testid="setting-free-until-input"
            />
            <p className="text-xs text-forest/50 mt-1">Ends at 23:59 SA time on this day. Leave empty to show "free during our launch period" with no countdown.</p>
          </div>
        </div>
        <Button onClick={saveSettings} className="rounded-full bg-sage hover:bg-sage-dark text-white" data-testid="settings-save-btn">Save settings</Button>
      </div>
    </div>
    <DemoCleanupCard />
    </div>
  );
}
